const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Lightweight analytics tracker for Culture Align
 * Tracks CTA clicks, form submissions, and Calendly interactions
 */
export const trackEvent = (eventName, properties = {}) => {
  const event = {
    event: eventName,
    properties,
    timestamp: new Date().toISOString(),
    page: window.location.pathname,
    referrer: document.referrer || 'direct',
  };

  // Log to console in development
  console.log('[Analytics]', eventName, properties);

  // Send to backend
  try {
    fetch(`${BACKEND_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(event),
    }).catch((err) => {
      console.warn('[Analytics] Failed to send event:', err?.message);
    });
  } catch (err) {
    console.warn('[Analytics] Tracker error:', err?.message);
  }
};

// Pre-defined event helpers
export const trackCTAClick = (buttonLabel, section) => {
  trackEvent('cta_click', { button_label: buttonLabel, section });
  // Meta Pixel
  if (window.fbq) window.fbq('trackCustom', 'CTAClick', { button: buttonLabel, section });
  // Google Tag
  if (window.gtag) window.gtag('event', 'cta_click', { button_label: buttonLabel, section });
};

export const trackFormSubmission = (formName, fields = {}) => {
  trackEvent('form_submission', { form_name: formName, ...fields });
  // Meta Pixel - Lead event
  if (window.fbq) window.fbq('track', 'Lead', { content_name: formName });
  // Google Tag - generate_lead event
  if (window.gtag) window.gtag('event', 'generate_lead', { event_category: 'form', event_label: formName });
};

export const trackCalendlyView = () => {
  trackEvent('calendly_view', { action: 'embed_shown' });
  // Meta Pixel - Schedule event
  if (window.fbq) window.fbq('track', 'Schedule');
  // Google Tag
  if (window.gtag) window.gtag('event', 'calendly_view', { event_category: 'engagement' });
};

export const trackSectionView = (sectionName) => {
  trackEvent('section_view', { section: sectionName });
};
